import React, { FunctionComponent } from 'react';

import Chip, { ChipProps } from '@gojob/ui-bits/Chip';
import Skeleton from '@gojob/ui-bits/Skeleton';
import Typography from '@gojob/ui-bits/Typography';

import useRoundNumber from '@gojob/ui-bits/hooks/useRoundNumber';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import useTranslation from 'src/translations/useTranslation';

export interface SalaryChipProps extends Omit<ChipProps, 'ref'> {
  loading?: boolean;
  grossHourlyRateWithCP?: number;
}

const SalaryChip: FunctionComponent<SalaryChipProps> = (props) => {
  const { loading, grossHourlyRateWithCP: grossHourlyRateWithCPAndIFM = 0, ...other } = props;

  const t = useTranslation();
  const { spacing } = useTheme();

  const roundedSalary = useRoundNumber(grossHourlyRateWithCPAndIFM);

  if (!loading && !roundedSalary) {
    return null;
  }
  return (
    <Chip dense css={{ boxShadow: 'unset', padding: spacing(1, 1.5) }} color="aliceBlue" {...other}>
      <Typography
        css={{ lineHeight: 1, fontWeight: 600, whiteSpace: 'nowrap' }}
        variant="messageSmall"
        color="bayOfMary"
      >
        {loading ? <Skeleton width={spacing(10)} /> : t('{count}_euros_by_hour', { count: roundedSalary })}
      </Typography>
    </Chip>
  );
};

export default SalaryChip;
